import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '@/environments/environment';

export interface AccountUiPreferencesDto {
    preset: string;
    primary: string;
    surface: string | null;
    dark_theme: boolean;
    menu_mode: string;
    menu_theme: string;
    card_style: string;
    updated_at?: string;
}

export interface ResponseWrapper<T> {
    content: T[];
}

@Injectable({
    providedIn: 'root'
})
/* v8 ignore start */
export class AccountUiPreferencesService {
/* v8 ignore stop */
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${environment.apiUrl}/accounts/preferences/ui`;

    getPreferences(): Observable<AccountUiPreferencesDto> {
        return this.http.get<ResponseWrapper<AccountUiPreferencesDto>>(this.baseUrl).pipe(
            map((res) => {
                if (res && res.content && res.content.length > 0) {
                    return res.content[0];
                }
                throw new Error('No preferences returned');
            })
        );
    }

    savePreferences(preferences: Partial<AccountUiPreferencesDto>): Observable<AccountUiPreferencesDto> {
        return this.http.put<ResponseWrapper<AccountUiPreferencesDto>>(this.baseUrl, preferences).pipe(
            map((res) => {
                if (res && res.content && res.content.length > 0) {
                    return res.content[0];
                }
                throw new Error('No preferences returned');
            })
        );
    }
}
